<template>
  <div>
    <b-modal
      size="lg"
      id="select-item"
      :title="
        type == 'MEDICINE' ? 'Selecionar Medicamento' : 'Selecionar Produto'
      "
      hide-footer
      no-close-on-backdrop
    >
      <div v-if="type == 'MEDICINE'">
        <SelectMedicineID
          :showMedicine="true"
          :newMedicine="false"
          v-on:selected="selected"
        />
      </div>

      <div v-else>
        <SelectProductID
          :showProduct="true"
          :newProduct="false"
          v-on:selected="selected"
        />
      </div>

      <div v-if="selectedItem">
        <div class="filter-group">
          <label class="filter-label">
            <i class="fas fa-list-ol filter-icon"></i>
            Quantidade
          </label>

          <v-text-field
            v-model="quantity"
            label="Quantidade"
            type="number"
            outlined
            dense
            hide-details
            class="modern-input"
            min="1"
            step="1"
          />
        </div>
      </div>

      <ErrorsMessages :errors="errors" />

      <div class="btn-modal-wrapper">
        <v-btn :disabled="loading" class="btn-save-modern" @click="create">
          <i class="fas fa-plus mr-2"></i>
          {{ loading ? "Salvando..." : "Cadastrar Itens" }}
        </v-btn>
      </div>
    </b-modal>
  </div>
</template>

<script>
import SelectMedicineID from "../Components/SelectMedicineID";

import SelectProductID from "../Components/SelectProductID";

import ErrorsMessages from "../Components/ErrorsMessages";

import toast from "../../lib/ToastNotification";

import api from "../../services/api";

export default {
  components: {
    SelectMedicineID,
    SelectProductID,
    ErrorsMessages,
  },

  props: {
    buy_id: [String, Number],

    type: String,
  },

  data() {
    return {
      loading: false,

      selectedItem: null,

      quantity: null,

      errors: [],
    };
  },

  methods: {
    async create() {
      try {
        this.loading = true;

        const id = this.selectedItem ? this.selectedItem.id : null;

        const { buy_id, type, quantity } = this;

        let params = {
          id,
          buy_id,
          type,
          quantity,
        };

        const response = await api.post("/buy-item", params);

        const { error, errors, message } = response.data;

        if (!error) {
          toast(message, "success");

          this.$emit("created");

          this.selectedItem = null;

          this.quantity = null;

          this.$bvModal.hide("select-item");
        } else {
          this.errors = errors;
        }

        this.loading = false;
      } catch (error) {
        this.loading = false;

        console.log(error);
      }
    },

    selected(medicine) {
      this.selectedItem = medicine;
    },
  },
};
</script>

<style scoped>
.btn-modal-wrapper {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
}
</style>

